import { styled, Box } from '@material-ui/core';
import { QRCodeSVG } from 'qrcode.react';

const QRCodeWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  margin: '0 16px',
});

const QRCode = styled(QRCodeSVG)({
  alignSelf: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 16,
});

const StoreImgWrapper = styled('a')({
  display: 'flex',
  justifyContent: 'center',
  width: 'fit-content',
  margin: '0 auto',
  marginTop: 16,
});

export {
  QRCodeWrapper,
  QRCode,
  StoreImgWrapper,
};
